module.exports = __webpack_public_path__ + "img/rencaidangan.bcd99da0.png";